jQuery(document).ready(function() {
    jQuery(".sub-menu").hide();
    jQuery('.toggle-nav').click(function(e) {
        //jQuery('.menu.main ul').slideToggle(500);
        jQuery('.burger-nav').slideToggle(500);
        jQuery(this).find(jQuery(".fas")).toggleClass('fa-bars').toggleClass('fa-bars');
 
        e.preventDefault();
    });
    // jQuery('.hasdropdown').hover(function(e) {
    //     jQuery('.hasdropdown ul').slideToggle(500);
    //     e.preventDefault();
    // });
    jQuery('.mobilehasdropdown a').click(function(e) {
        jQuery('.mobilehasdropdown ul').slideToggle(500);

    });
	jQuery('.accordiontitle').click(function(){
		jQuery(this).siblings('.accordioncontent').slideToggle();
		jQuery(this).toggleClass('contentopen');
        jQuery(this).find(jQuery(".fas")).toggleClass('fa-plus').toggleClass('fa-minus');
	}); 

    jQuery('#tabs li a:not(:first)').addClass('inactive');
    jQuery('#tabs li a:first').addClass('isactivetab');
    jQuery('.tabcontent').hide();
    jQuery('.tabcontent:first').show();
    
    jQuery('#tabs li a').click(function(){
    jQuery('#tabs li a').removeClass('isactivetab');
    var t = jQuery(this).attr('name');
    if(jQuery(this).hasClass('inactive')){ //this is the start of our condition 
        jQuery('#tabs li a').addClass('inactive');           
        jQuery(this).removeClass('inactive');
        jQuery(this).addClass('isactivetab');
        jQuery('.tabcontent').hide();
        jQuery('#'+ t).fadeIn('slow');
    }
    
    });
});

document.addEventListener('DOMContentLoaded', function () {
    new Splide('#hero-search-block', {
      type: 'loop',
      perPage: 1,
      focus: 'left',
      pagination: false,
      arrows: false,
      autoplay: true
    }).mount();
});

document.addEventListener('DOMContentLoaded', function () {
    new Splide('#latest-news-block', {
      type: 'slide',
      perPage: 2,
      focus: 'left',
      gap: '30px',
      pagination: false,
      breakpoints: {

        1024: {
          perPage: 2,
          pagination: false,

        },
        768: {
          perPage: 1,
          pagination: true,
          arrows: false,

        },
        430: {
          perPage: 1,
          pagination: true,
          arrows: false,
        },
      },
      classes: {
        pagination: 'splide__pagination slider-pagination',
      },
    }).mount();
});